import Avatar from '@/components/Avatar'
import Block from '@/components/Block'
import Icon from '@/components/Icon'
import Layout, { Stack } from '@/components/Layout'
import Tag from '@/components/Tag'
import Text from '@/components/Text'
import { GuideClassPageSection } from '@/shared/api-generated-types'
import DOMPurify from 'dompurify'
import { useTranslation } from 'next-i18next'

export interface Props extends Partial<GuideClassPageSection> {
  className?: string
}

const GuideBlock = ({ content, className = '' }: Props): JSX.Element => {
  const { t } = useTranslation('classes')
  return (
    <Block theme="white" className={className}>
      <Layout spacing="sm">
        <Stack y alignItems="center">
          <Avatar size="lg" src={content?.avatarUrl || ''} alt={content?.name} />
          <Text>{content?.name}</Text>
          <Text size="xs" weight="sm">
            {content?.title}
          </Text>
        </Stack>
      </Layout>
      <Layout spacing="sm" className="pt-md">
        <Stack y justifyContent="center" alignItems="center">
          <Text className="fc-dark-grey" size="xs" weight="sm">
            <Icon name="pin-filled" size={16} /> {content?.location}
          </Text>
          {/*
                  TODO: Guide languages output
                  <Text className="fc-dark-grey" size="xs" weight="sm">
                    <Icon name="lang" size={16} /> TODO: lang
                  </Text>
                  */}
        </Stack>
      </Layout>
      <Layout>
        <Stack y alignItems="center">
          <Text tag="div" size="xs" weight="sm" className="mb-lg">
            {content?.tagline.split('\n').map((para, i) => (
              <p
                key={i}
                className="pt-md"
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(para),
                }}
              />
            ))}
          </Text>
        </Stack>
      </Layout>
      {content?.askMeAbout?.length ? (
        <>
          <Text tag="div" size="xs" weight="md" uppercase>
            {t('askMeAbout')}
          </Text>
          <div className="pt-sm">
            {content.askMeAbout.map((item, i) => (
              <Tag key={i} variant="pill" theme="grey">
                {`# ${item}`}
              </Tag>
            ))}
          </div>
        </>
      ) : null}

      <Layout spacing="sm" className="pt-lg pb-lg">
        <Stack x justifyContent="space-around">
          {/* TODO: Guide action driven by API
          Or we could be explicit about what buttons
          are here since it's a specific section

          <Button
            size="md"
            stretch
            label={t('cta.viewProfile')}
            iconRight="chevron-right"
            theme="primaryOutline"
            iconSize={15}
          />
          <Button size="md" stretch label={t('cta.follow')} theme="primary" />
            */}
        </Stack>
      </Layout>
    </Block>
  )
}
export default GuideBlock
